// apps/website/src/components/GoogleAnalyticsTracker.tsx

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// For best practice, you could move this to a .env file:
// const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;
const GA_MEASUREMENT_ID = 'G-N34HL2QMY3';

// Augment the window interface to include gtag for TypeScript
declare global {
  interface Window {
    gtag?: (
      command: 'config' | 'event',
      targetId: string,
      config?: { page_path?: string }
    ) => void;
  }
}

/**
 * This component tracks page views for a Single Page Application (SPA)
 * by listening to route changes and sending a `page_view` event to Google Analytics.
 */
export const GoogleAnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (!GA_MEASUREMENT_ID) {
      console.warn('Google Analytics Measurement ID is not defined.');
      return;
    }

    // Check if the gtag function is available on the window object
    if (typeof window.gtag === 'function') {
      // The `config` command with a `page_path` sends a `page_view` event for the new page.
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location.pathname, location.search]);

  // This component does not render any UI
  return null;
};